import { useContext } from 'react';
import { SupportChatContext } from './SupportChatContext';

function useSupportChat() {
  return useContext(SupportChatContext);
}

export default useSupportChat;
